var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.375C5.57967 0.375 0.375 5.57967 0.375 12C0.375 18.4203 5.57967 23.625 12 23.625C18.4203 23.625 23.625 18.4203 23.625 12C23.625 5.57967 18.4203 0.375 12 0.375ZM12 22.125C6.43762 22.125 1.875 17.6224 1.875 12C1.875 6.43767 6.37758 1.875 12 1.875C17.5624 1.875 22.125 6.37758 22.125 12C22.125 17.5623 17.6224 22.125 12 22.125ZM18.6389 9.2362L10.1789 17.6283C9.95836 17.8471 9.6022 17.8457 9.38344 17.6251L5.35791 13.5671C5.13914 13.3465 5.14055 12.9904 5.36109 12.7716L5.76047 12.3755C5.98102 12.1567 6.33717 12.1581 6.55594 12.3787L9.78919 15.638L17.4505 8.03817C17.671 7.81941 18.0272 7.82081 18.246 8.04136L18.6421 8.44073C18.8609 8.66128 18.8595 9.01744 18.6389 9.2362Z",
    fill: "#005E9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.3957bedc240700d1868f1d8ed6bddf00.svg";
export { ForwardRef as ReactComponent };